import { render, staticRenderFns } from "./hospitaldetail.vue?vue&type=template&id=63c0e3fb&scoped=true&"
import script from "./hospitaldetail.vue?vue&type=script&lang=js&"
export * from "./hospitaldetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c0e3fb",
  null
  
)

export default component.exports